import { render } from "./InterfaceNoData.vue?vue&type=template&id=658f97aa&scoped=true"
import script from "./InterfaceNoData.vue?vue&type=script&lang=js"
export * from "./InterfaceNoData.vue?vue&type=script&lang=js"

import "./InterfaceNoData.vue?vue&type=style&index=0&id=658f97aa&scoped=true&lang=scss"

import exportComponent from "/tmp/f3315f41-3418-4066-838e-b0c15008937b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658f97aa"]])

export default __exports__